import HttpService from './HttpService';
const API_ENDPOINT = '/section';

const SectionService = {
  async getSections() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getSectionsPaginated(pageConfig) {
    const pageConfigParams =  new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(`${API_ENDPOINT}-paginated?${pageConfigParams}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async addSection(data) {
    try {
       const response = await HttpService.post(API_ENDPOINT, data);
       return response.data;
    } catch (error) {
        console.error('Error adding section:', error);
        throw error;
    }
},
  async updateSection(sectionId, data) {
  try {
      const response = await HttpService.put(`${API_ENDPOINT}/${sectionId}`, data);
      return response.data;
  } catch (error) {
      console.error('Error updating section:', error);
      throw error;
  }
  },
  async deleteSection(sectionId) {
  try {
      const response = await HttpService.delete(`${API_ENDPOINT}/${sectionId}`);
      return response.data;
  } catch (error) {
      console.error('Error deleting section:', error);
      throw error;
  }
  },
};

export default SectionService;